import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {appSelector, setJbpDetail} from '../../../../../redux/slices/appSlices'

export const SelectStatus = () => {
  const {t} = useTranslation()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const dispatch = useAppDispatch()

  const selected = jbp?.is_active === true ? true : false

  const handleChange = (value: 'true' | 'false' | string) => {
    dispatch(setJbpDetail({...jbp, is_active: value === 'true' ? true : false}))
  }

  return (
    <Form.Group controlId='select-status'>
      <Form.Label>Status</Form.Label>
      <Form.Select onChange={(e: any) => handleChange(e.target.value)}>
        <option value=''>{`${t('Choose')} Status`}</option>

        <option selected={selected} value='true'>
          {selected ? t('Active') : t('Non-Active')}
        </option>

        <option selected={!selected} value='false'>
          {!selected ? t('Active') : t('Non-Active')}
        </option>
      </Form.Select>
    </Form.Group>
  )
}
